import Dropdown from './dropdown';

export default angular.module('spa.notifications', [
  Dropdown
]).name;


// WEBPACK FOOTER //
// ./src/components/notifications/index.js